import {createSelector} from 'reselect'

const linksSelector = state => state.links.links

/* USER */
// Ajoute ?provider=pros pour vérifier que l'utilisateur est bien un Pro (pas un Customer)
export const getUserLink = createSelector(
    linksSelector,
    links => links['user.get']?.uri ? `${links['user.get'].uri}?provider=pros` : null
)

export const getUserLogoutLink = createSelector(
    linksSelector,
    links => links['auth.logout']?.uri
)

/* Tasks */
export const getTasksAnTotalLink = createSelector(
    linksSelector,
    links => links['tasks.an.total']?.uri
)

export const getTaskAnFirstLink = createSelector(
    linksSelector,
    links => links['tasks.an.first']?.uri
)

export const getTaskByIdLink = createSelector(
    linksSelector,
    links => links['tasks.checkdoc.get']?.uri
)

export const getTasksAnValidateFieldsLink = createSelector(
    linksSelector,
    links => links['tasks.an.validate_fields']?.uri
)

export const getTasksChangeTypeLink = createSelector(
    linksSelector,
    links => links['tasks.change_type']?.uri
)

export const getTasksReassignLink = createSelector(
    linksSelector,
    links => links['tasks.reassign']?.uri
)

export const getTasksReassignDocumentLink = createSelector(
    linksSelector,
    links => links['tasks.reassign_document']?.uri
)

export const getDocumentRetryLink = createSelector(
    linksSelector,
    links => links['document.retry']?.uri
)

/* DASHBOARD */

export const getDashboardLink = createSelector(
    linksSelector,
    links => links['dashboard.afn']?.uri
)

export const settingsLink = createSelector(
    linksSelector,
    links => links['features.status'].uri
)

/* CONTROLLED DOCUMENTS */
export const getControlledDocumentsLink = createSelector(
    linksSelector,
    links => links['controlled.documents']?.uri
)

export const getControlledDocumentsValidatedLink = createSelector(
    linksSelector,
    links => links['controlled.documents.validated']?.uri
)
